import React from 'react'
import styles from './ButtonSmallIcon.module.scss'
import { IconType, JWayIcon } from '../../../assets/JWayIcons';


export interface ButtonSmallIconProps {
    label?: string;
    children?: React.ReactNode;
    iconType?: IconType;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    color?: string;
    colorIcon?: string;
    colorBackground?: string;
    width?: string;
    variant?: "pils" | "stack" | "stack-rounded-icon"
    valueText?: string;
    valueRender?: () => JSX.Element;
    iconSize?: number;

}
export default function ButtonSmallIcon({iconType, children, onClick, label, color , width, valueText, variant= "pils", valueRender, colorBackground, colorIcon, iconSize}: ButtonSmallIconProps) {

  const getIconSize = () => {
    switch (variant) {
      case "pils":
        return 12
      case "stack": 
        return 17
      
      case "stack-rounded-icon":
        return 17
      default:
        return 12
    }
  }

  return (
    <button style={{color, borderColor: color, width}}className={[styles["btn"], styles["btn--"+variant], onClick ? styles["btn--"+variant+"--clickable"] : "", onClick ? styles["clickable"] : ""].join(" ")} onClick={onClick}>
        <div style={{backgroundColor: colorBackground}} className={[styles["btn__icon"], styles["btn__icon--"+variant], styles["icon--"+variant]].join(" ")}>
            {
                iconType
                ? <JWayIcon type={iconType} size={iconSize || getIconSize()} color={color || colorIcon || "#a1a1a1"}/>
                : null
            }
        </div>
      <p className={[styles["btn__label"], styles["btn__label--"+variant]].join(" ")}>{label}<span className={[styles["btn__value"]].join(" ")}> {valueText} {valueRender && valueRender()}{children}</span></p>
    </button>
  )
}
